module.exports = __webpack_public_path__ + "img/18.103.A.2f3dc938.png";